import React from "react"
import Layout from "../components/Layout"

const AboutPage = () => (
  <>
    <Layout>
      <h1>What is Bonneville?</h1>
      <p>
        Bonneville is a GatsbyJS theme developed & maintained by{" "}
        <a href="https://www.morganbaker.dev" target="_blank" rel="noreferrer">
          Morgan Baker
        </a>
        . Built using ReactJS architecture, it benefits from an app-like
        experience with easy to maintain components. If you use Bonneville as
        the base of your next project you will find expanding its struture
        simple to extend.
      </p>
      <h3>Getting Started</h3>
      <p>
        If you're new to web development or GatsbyJS the best place for you to
        start is with their{" "}
        <a
          href="https://www.gatsbyjs.com/docs"
          target="_blank"
          rel="noreferrer"
        >
          excellent documentation
        </a>
        . Here you will find well-written guides for absolute beginners to
        Javascript experts.
      </p>
      <h2>Mauris nec pulvinar est</h2>
      <p>
        Quisque et aliquam magna. Pellentesque suscipit odio condimentum,
        faucibus ante et, fringilla ipsum. In scelerisque laoreet lorem, non
        eleifend ex eleifend vitae. Phasellus fermentum placerat turpis, eget
        aliquet turpis auctor in.
      </p>
      <p>
        Nulla facilisi. Fusce id elit ac eros fringilla semper. Suspendisse sed
        placerat metus, sit amet rhoncus lectus. Morbi ultrices auctor mauris,
        nec volutpat lacus tristique interdum.
      </p>
      <h2>Quisque et aliquam magna</h2>
      <p>
        Curabitur egestas felis sed scelerisque facilisis. Nunc id semper nisi.
        Vivamus suscipit, ex at efficitur sodales, diam elit lacinia sapien, eu
        interdum velit magna quis urna. Sed accumsan viverra augue id imperdiet.{" "}
      </p>
    </Layout>
  </>
)

export default AboutPage
